export default {
  stepper: {
    description: 'Onboarding du restaurant',
    steps: {
      confirm_email: "Confirmer l'adresse e-mail",
      add_store_details: 'Ajouter les informations de votre établissement',
      add_personal_details: 'Ajouter vos informations personnelles',
      add_bank_details: 'Ajouter les coordonnées bancaires pour les virements',
      add_tax_details: 'Votre entreprise est-elle assujettie à la TVA ?',
      upload_business_doc: "Justificatif d'entreprise",
      upload_personal_doc: "Justificatif d'identité",
      confirm_details: 'Être payé',
    },
  },
  completed: {
    title: 'Intégration terminée',
    description:
      "Votre intégration est terminée. Vous pouvez ajouter des documents ici à tout moment, par exemple une nouvelle pièce d'identité d'un partenaire ou une pièce d'identité renouvelée.",
  },
  toasts: {
    failed_to_skip_verification_step: "Échec de l'ignorance de l'étape de vérification. Veuillez réessayer",
  },
};
